<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Mon compte
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Information personnelle &amp; mot de passe</p>
  </div>

  <!-- Main card with tabs -->
  <div class="afri-card">
    <ul class="afri-tabs nav" style="padding: 0 1.5rem;">
      <li class="nav-item">
        <a role="tab" class="nav-link active" id="tab-c1-0" data-bs-toggle="tab" href="#tab-animated1-0" aria-selected="true">
          <span class="nav-text">Information personnelle</span>
        </a>
      </li>
      <li class="nav-item">
        <a role="tab" class="nav-link" id="tab-c1-1" data-bs-toggle="tab" href="#tab-animated1-1" aria-selected="false">
          <span class="nav-text">Mot de passe</span>
        </a>
      </li>
      <li class="nav-item">
        <a role="tab" class="nav-link" id="tab-c1-2" data-bs-toggle="tab" href="#tab-animated1-2" aria-selected="false">
          <span class="nav-text">Créditer un compte</span>
        </a>
      </li>
    </ul>

    <div class="tab-content" style="padding: 1.5rem;">
      <div class="tab-pane active" id="tab-animated1-0" role="tabpanel">
        <form #userForm="ngForm" (ngSubmit)="update(userForm.value)">
          <div class="mb-3">
            <label class="afri-label">Email</label>
            <input name="email" placeholder="Email ici..." type="email" class="afri-input" required [(ngModel)]="user.email">
          </div>
          <button class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d; margin-top: 0.5rem;" [disabled]="userForm.invalid || loading" type="submit">
            Sauvegarder mes informations <app-loading [isVisible]="loading"></app-loading>
          </button>
        </form>
      </div>

      <div class="tab-pane" id="tab-animated1-1" role="tabpanel">
        <form #mpForm="ngForm" (ngSubmit)="changePassword(mpForm.value)">
          <div class="mb-3">
            <label class="afri-label">Ancien mot de passe</label>
            <input name="old_password" placeholder="Ancien mot de passe" type="password" class="afri-input" required ngModel>
          </div>
          <div class="mb-3">
            <label class="afri-label">Nouveau mot de passe</label>
            <input name="new_password" placeholder="Nouveau mot de passe" type="password" class="afri-input" required ngModel>
          </div>
          <div class="mb-3">
            <label class="afri-label">Confirmer mot de passe</label>
            <input name="confirm_password" placeholder="Confirmer mot de passe" type="password" class="afri-input" required ngModel>
          </div>
          <button class="btn-afri-success" style="margin-top: 0.5rem;" [disabled]="mpForm.invalid || loading" type="submit">
            Changer le mot de passe <app-loading [isVisible]="loading"></app-loading>
          </button>
        </form>
      </div>

      <div class="tab-pane" id="tab-animated1-2" role="tabpanel">
        <form #walletForm="ngForm" (ngSubmit)="upWallet(walletForm.value)">
          <div class="mb-3">
            <label class="afri-label">Utilisateur</label>
            <ng-select name="login" ngModel>
              <ng-option *ngFor="let u of users" [value]="u.id">{{u.lastname}} {{u.firstname}}</ng-option>
            </ng-select>
          </div>
          <div class="mb-3">
            <label class="afri-label">Montant</label>
            <input name="amount" placeholder="Montant à créditer" type="text" class="afri-input" required ngModel>
          </div>
          <button class="btn-afri-outline" style="color: #d97706; border-color: #fcd34d; margin-top: 0.5rem;" [disabled]="walletForm.invalid || loading" type="submit">
            Créditer <app-loading [isVisible]="loading"></app-loading>
          </button>
        </form>
      </div>
    </div>
  </div>

</div>
